var map = {
	"./number-1.svg": 680,
	"./number-2.svg": 681,
	"./number-3.svg": 682,
	"./number-4.svg": 683,
	"./number-5.svg": 684,
	"./number-6.svg": 685,
	"./number-7.svg": 686,
	"./number-8.svg": 687,
	"./number-9.svg": 688,
	"./number-shine-1.svg": 689,
	"./number-shine-2.svg": 690,
	"./number-shine-3.svg": 691,
	"./number-shine-4.svg": 692,
	"./number-shine-5.svg": 693,
	"./number-shine-6.svg": 694,
	"./number-shine-7.svg": 695,
	"./number-shine-8.svg": 696,
	"./number-shine-9.svg": 697
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 679;